import { FC } from "react";
import { AlertDialog as AlertDialogPrimitive } from "radix-ui";
import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/_atoms/alert-dialog";

export interface DeleteConfirmationProps extends AlertDialogPrimitive.AlertDialogProps {
  title?: string;
  description?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

export const DeleteConfirmation: FC<DeleteConfirmationProps> = (props) => {
  const { t } = useTranslation("common");
  const title = props.title ?? t("deleteConfirmation.title");
  const description =
    props.description ?? t("deleteConfirmation.description");
  const handleCancelClicked = props.onCancel;
  const handleConfirmClicked = props.onConfirm;

  return (
    <>
      <AlertDialog {...props}>
        <AlertDialogContent className="top-[1%] translate-y-[0%] md:top-[30%]">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-left text-base font-medium">{title}</AlertDialogTitle>
            <AlertDialogDescription className="text-left">{description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="mt-2 flex flex-row items-center justify-end gap-2">
            <AlertDialogCancel className="m-0 h-9 rounded-md px-2" onClick={handleCancelClicked} aria-label={t("actions.cancel")}>
              {props.cancelButtonText ?? t("actions.cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="m-0 h-9 rounded-md px-2"
              data-testid="confirm-delete-button"
              onClick={handleConfirmClicked}
              aria-label={t("actions.delete")}
            >
              {props.confirmButtonText ?? t("actions.delete")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
